import $ from 'jquery';

/**
 *
 * @module left-menu-container
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-09-01 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-11-28 using ChatGPT
 */

class LeftMenuContainer {

  constructor(element) {
    this.$el = $(element);
    this.dataModule = this.$el.data('module');
    this.setupDefaults();
    this.setBinds();
  }

  setupDefaults() {
    this.$mobileContentDropdown = this.$el.find('.mobile-items');
  }

  setBinds() {
    if (this.dataModule === 'original' && this.$mobileContentDropdown.length > 0 && this.$mobileContentDropdown !== undefined) {
      this.$mobileContentDropdown.on('change', (event) => {
          // Get the new URL from the value of the selected option
          const newUrl = event.target.value; 
  
          // Navigate to the new URL
          window.location.href = newUrl;
      });
    }  
  }

}

export default LeftMenuContainer;
